<template>
  <SpinnerComp v-if="loading" />
  <div v-else class="mt-8">
    <h2 class="text-lg font-bold">Seguimiento Facturas de Proveedores</h2>
    <div class="p-4 md:flex md:space-x-4">
      <div>
        <label class="block">Orden de Compra (KOC)</label>
        <input
          v-model="order"
          placeholder="Orden de Compra"
          class="border rounded-md p-2 border-black"
        />
      </div>
      <div class="flex justify-center">
        <button
          @click="agregarSeguimiento"
          class="bg-blue-500 text-white px-4 py-2 border rounded mt-2"
        >
          Agregar Factura
        </button>
      </div>
    </div>
    <div>
      <SearchComp @update-query="updateSearchQuery" />
      <div class="overflow-x-auto">
        <div class="max-h-[50vh] overflow-y-auto">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg">
            <thead class="bg-gray-700">
              <tr>
                <th
                  v-for="column in columns"
                  :key="column.key"
                  class="px-3 py-3 text-left text-xs font-medium text-white border-b"
                >
                  {{ column.label }}
                </th>
                <th
                  class="px-3 py-1 text-left text-xs font-medium text-white border-b"
                >
                  Acción
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in paginatedRows" :key="index">
                <td
                  v-for="column in columns"
                  :key="column.key"
                  class="px-3 py-1 text-sm text-gray-800 border-b"
                >
                  <template v-if="column.key === 'estatus'">
                    <select
                      v-model="row[column.key]"
                      @change="handleChangeOptions(row[column.key], row['id'])"
                      class="border border-gray-300 rounded px-2 py-1 w-32 lg:w-40"
                    >
                      <option value="" disabled>Seleccione un estado</option>
                      <option value="0">pendiente</option>
                      <option value="1">pagado</option>
                      <option value="2">vencido</option>
                    </select>
                  </template>
                  <template v-else>
                    {{ row[column.key] }}
                  </template>
                </td>
                <td class="px-3 py-1 text-sm text-gray-800 border-b">
                  <div class="flex space-x-2">
                    <button
                      v-for="(option, idx) in options"
                      :key="idx"
                      @click="handleOptionAction(option.action, row)"
                      :class="[
                        option.color,
                        'text-white',
                        'rounded-full',
                        'p-2',
                        'mr-2',
                        'mt-2',
                        'mb-2',
                        'flex',
                      ]"
                    >
                      <span
                        :class="
                          option.icon.includes('material-symbols-outlined')
                            ? 'material-icons'
                            : option.icon.split(' ')[0]
                        "
                      >
                        {{ option.icon.split(" ").pop() }}
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Sección de paginación para las tablas -->
    <div class="flex justify-between items-center mt-4">
      <button
        @click="prevPage"
        :disabled="currentPage === 1"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 inline-block align-middle"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <div>{{ currentPage }} / {{ totalPages }}</div>
      <button
        @click="nextPage"
        :disabled="currentPage === totalPages"
        class="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 inline-block align-middle"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeDelete"
      @confirm="deleteFactura"
    />
  </div>
</template>

<script>
import SearchComp from "@/components/SearchComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    SearchComp,
    DeleteComp,
    SpinnerComp,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      id: null,
      isDeleteOpen: false,
      deleteMessage: "",
      searchQuery: "",
      currentPage: 1,
      rowsPerPage: 4,
      order: "",
      selectedSupplier: "", // Almacena el ID del proveedor seleccionado
      suppliers: [], // Lista de proveedores
      columns: [
        { label: "Proveedor", key: "idProveedor" },
        { label: "Factura", key: "numFactura" },
        { label: "Fecha", key: "fecha" },
        { label: "D_credito", key: "credito" },
        { label: "Vence", key: "vence" },
        { label: "Estatus", key: "estatus" },
        { label: "Importe", key: "importe" },
        { label: "Iva", key: "iva" },
        { label: "Total", key: "total" },
        { label: "KOC", key: "koc" },
        { label: "Fecha Pago", key: "fechaPago" },
        { label: "Referencia", key: "referencia" },
      ],
      rows: [],
      options: [
        {
          icon: "material-symbols-outlined picture_as_pdf",
          action: "pdf",
          color: "bg-red-500",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  computed: {
    filteredRows() {
      if (!this.searchQuery) return this.rows;

      return this.rows.filter((row) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
    },
    paginatedRows() {
      const start = (this.currentPage - 1) * this.rowsPerPage;
      const end = start + this.rowsPerPage;
      return this.filteredRows.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredRows.length / this.rowsPerPage);
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
    closeDelete() {
      this.isDeleteOpen = false;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    updateSearchQuery(query) {
      this.searchQuery = query;
      this.currentPage = 1;
    },
    handleChangeOptions(status, id) {
      this.$axios
        .put(`/changeState/${id}`, {
          state: status,
        })
        .then((response) => {
          alert(response.data.message);
          this.getFacturas();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    handleOptionAction(action, row) {
      const actions = {
        pdf: () => {
          this.generatePdf(row.koc);
        },
        delete: () => {
          this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.koc}?`;
          this.id = row.id;
          this.isDeleteOpen = true;
        },
      };
      if (actions[action]) {
        actions[action]();
      }
    },
    deleteFactura() {
      this.$axios
        .delete(`/deleteSeg/${this.id}`)
        .then((response) => {
          this.closeDelete();
          alert(response.data.message);
          this.getFacturas();
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        });
    },
    getFacturas() {
      this.loading = true;
      this.$axios
        .get("/getSeg")
        .then((response) => {
          this.rows = response.data.facturas.map((factura) => ({
            id: factura.id,
            idProveedor: factura.nombreProveedor,
            numFactura: factura.numFactura,
            fecha: factura.fecha,
            credito: factura.d_credito,
            vence: factura.vence,
            estatus: factura.estatus,
            importe: factura.importe,
            iva: factura.iva,
            total: factura.total,
            koc: factura.koc,
            fechaPago: factura.fechaPago,
            referencia: factura.referencia,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message || "Error al obtener las facturas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    agregarSeguimiento() {
      if (this.order === "") return;
      this.$axios
        .post("/registerSeg", {
          koc: this.order,
          proveedor: this.selectedSupplier,
        })
        .then((response) => {
          alert(response.data.message);
          this.getFacturas();
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    },
    generatePdf(id) {
      this.$axios
        .get(`/generate-pdf-OC/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const newTab = window.open(url, "_blank");
          if (
            !newTab ||
            newTab.closed ||
            typeof newTab.closed === "undefined"
          ) {
            const link = document.createElement("a");
            link.href = url;
            link.download = `archivo-${id}.pdf`;
            link.click();
            alert(
              "El PDF no pudo abrirse en una nueva ventana. Se descargará automáticamente."
            );
          }
        })
        .catch((error) => {
          alert(error.response?.data?.message || "Error al generar el PDF");
        });
    },
  },
  mounted() {
    this.getFacturas();
  },
};
</script>
